import { useNavigate } from 'react-router-dom';
import { Button, Container, Card } from 'react-bootstrap';
import { AiOutlineClockCircle } from 'react-icons/ai';
import styled from 'styled-components';

export const AuthStyled = styled.div`
  min-height: 100vh;
  background: linear-gradient(30deg, #9459d0 0%, #027c8b 50%, #0d4693 100%);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledCard = styled(Card)`
  max-width: 600px;
  padding: 30px;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  text-align: center;
`;

const ErrorAuthenticationTokenPage: React.FC = () => {
  const navigate = useNavigate();

  function handleLogout(): void {
    localStorage.clear();
    navigate('/');
    // eslint-disable-next-line no-restricted-globals
    location.reload();
  }

  return (
    <AuthStyled>
      <StyledCard>
        <Card.Body>
          <AiOutlineClockCircle color={'#fada0b'} style={{ fontSize: 120 }} />
          <Card.Title className="mt-4" style={{ fontSize: '28px', fontWeight: 'bold' }}>
            Sessão Expirada
          </Card.Title>
          <Card.Text style={{ fontSize: '18px', marginTop: '10px', lineHeight: '1.5' }}>
            Parece que sua sessão expirou por questões de segurança. Para continuar utilizando a aplicação, será necessário fazer login novamente. Isso garante
            que suas informações estão protegidas e seguras.
            <br />
            <strong>Por favor, faça login novamente abaixo:</strong>
          </Card.Text>
          <Button variant="primary" onClick={handleLogout}>
            Logar novamente
          </Button>
        </Card.Body>
      </StyledCard>
    </AuthStyled>
  );
};

export default ErrorAuthenticationTokenPage;
